<template>
  <div
    class="save-money-header"
    :style="{ background: `url(${item.display_img_url})  no-repeat` }"
  >
    <div class="title">{{ item.name }}</div>
    <div class="card-number">{{ cardNumber }}</div>
    <div class="desc-wrap">
      <div class="desc">{{ item.desc }}</div>
      <div class="time">{{ expireTime }} 到期</div>
    </div>
    <div class="btn" @click="handleOpenCard">再次开通</div>
    <div class="btn-tip">权益翻倍</div>

    <van-popup v-model="showPopup" position="center" class="popup-content">
      <div class="popup-title">开卡即享超值权益</div>
      <van-field
        v-model="inputValue"
        placeholder="请输入手机号"
        class="action-input"
        :disabled="true"
        :maxlength="11"
      />
      <div class="action-btn">
        <div class="btn-value">
          <span class="btn-value-text">首月</span>
          <span class="btn-value-unit">¥</span>
          1
        </div>
        <div class="btn-text" @click="activeMember">立即开卡</div>
      </div>
      <div class="action-desc">
        <p>
          次月起按9.9元自动续费，可随时取消，<span
            class="link"
            @click="openRulePopup"
            >详细开通规则</span
          >
        </p>
        <div class="agree-wrap">
          <van-radio
            v-model="isAgree"
            class="radio-wrap"
            :icon-size="14"
            name="1"
          />
          我已阅读并同意<span class="link" @click="showArgument"
            >《服务协议》</span
          >
        </div>
      </div>
    </van-popup>
    <OpenRulePopup :value.sync="showRulePopup" />
  </div>
</template>

<script>
import { defineComponent, computed, ref } from "@vue/composition-api";
import Vue from "vue";

import { useStore, useRoute } from "@/components/use/base";
import { signByPhone, queryMemberCardInfo } from "@/apis/product";
import OpenRulePopup from "@/views/SaveMoneyCard/components/OpenRulePopup.vue";

const vm = Vue.prototype;

export default defineComponent({
  props: ["item"],
  components: {
    OpenRulePopup,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const { channel_source, auth_code } = route.query;
    const showPopup = ref(false);
    const showRulePopup = ref(false);
    const isAgree = ref("");
    const inputValue = ref(store.state.userInfo.login_phone_number);

    const cardNumber = computed(() => store.state.userInfo.card_number);
    const expireTime = computed(
      () => store.state.userInfo.card_expiry_date?.[0]
    );

    const handleOpenCard = () => {
      showPopup.value = true;
    };

    const activeMember = async () => {
      if (!/^1[3-9]\d{9}$/.test(inputValue.value)) {
        vm.$toast("请输入正确的手机号");
        return;
      }
      if (!inputValue.value) {
        vm.$toast("请输入手机号");
        return;
      }
      if (!isAgree.value) {
        vm.$toast("请先阅读并同意服务协议");
        return;
      }
      const { data } = await queryMemberCardInfo({
        phone_number: inputValue.value,
        access_code: auth_code,
      });
      const cardList = data?.card_list || [];
      const openId = data?.open_id || "";
      const arr = cardList?.filter((item) => !item.is_active) || [];
      if (arr.length === 0) {
        vm.$toast("当日会员卡已售罄，请次日重试");
        return;
      }
      const { data: signData } = await signByPhone({
        phone_number: inputValue.value,
        namespace: arr[0].namespace_name,
        item_code: arr[0].package_name,
        source: channel_source || "default",
        open_id: openId,
        access_code: auth_code,
      });
      window.location.href = signData.sign_url;
    };

    const showArgument = () => {
      location.href = "https://cdn.xiangshuheika.com/h5/agreement/xssqk.html";
    };

    const openRulePopup = () => {
      showRulePopup.value = true;
    };

    return {
      cardNumber,
      expireTime,
      showPopup,
      isAgree,
      inputValue,
      showRulePopup,
      handleOpenCard,
      activeMember,
      showArgument,
      openRulePopup,
    };
  },
});
</script>

<style lang="less" scoped>
.save-money-header {
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  width: 306px;
  height: 109px;
  border-radius: 8px;
  background-size: 100% !important;
  position: relative;

  .btn {
    position: absolute;
    top: 17px;
    right: 11px;
    width: 78px;
    height: 21px;
    background: linear-gradient(136deg, #fdf3da 0%, #eec08c 100%);
    border-radius: 11px;

    font-size: 12px;
    color: #784105;
    line-height: 21px;
    text-align: center;
  }

  .btn-tip {
    position: absolute;
    top: 6px;
    right: 11px;
    padding: 0 5px;
    height: 12px;
    background: linear-gradient(251deg, #ff8133 0%, #ff2f2e 100%);
    border-radius: 8px 8px 0px 7px;
    font-size: 8px;
    color: #ffffff;
    line-height: 12px;
    text-align: center;
    white-space: nowrap;
  }

  .title {
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 500;
    font-size: 16px;
    color: #f5d2b3;
    line-height: 16px;
    margin-top: 16px;
    margin-left: 16px;
  }

  .card-number {
    font-weight: 400;
    font-size: 10px;
    color: #f5d2b3;
    line-height: 17px;
    margin-left: 16px;
    margin-top: 7px;
  }

  .desc-wrap {
    color: #f5d2b3;
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 20px;
    font-size: 10px;
    display: flex;
    justify-content: space-between;
  }
}

.popup-content {
  width: 295px;
  height: 197px;
  background: linear-gradient(180deg, #ffecd5 0%, #ffffff 100%), #ffffff;
  border-radius: 7px;

  .popup-title {
    font-weight: 600;
    font-size: 15px;
    color: #222222;
    line-height: 18px;
    text-align: center;
    margin-top: 13px;
  }

  .action-input {
    margin: 0 auto;
    margin-top: 13px;

    border-radius: 8px;
    height: 33px;
    width: 275px;

    /deep/ .van-field__control {
      line-height: 16px;
      text-align: center;
    }
  }

  .action-btn {
    margin: 0 10px;
    margin-top: 21px;
    height: 42px;
    background: url("../../../../../assets/images/btn-bg.png") no-repeat;
    background-size: 100%;
    border-radius: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .btn-value {
    color: #ffe29e;
    width: 153px;
    font-size: 18px;
    text-align: center;
    line-height: 43px;
    > span {
      font-size: 10px;
      margin: 2px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .btn-text {
    width: 138px;
    font-size: 15px;
    line-height: 43px;
    color: #642407;
    text-align: center;
    font-weight: 500;
    line-height: 25px;
  }

  .action-desc {
    margin-top: 8px;
    font-weight: 400;
    font-size: 10px;
    color: #999999;
    line-height: 16px;
    text-align: center;

    .link {
      color: #0170fe;
    }

    .agree-wrap {
      display: flex;
      justify-content: center;
      margin-top: 4px;

      .radio-wrap {
        margin-right: 4px;
      }
    }
  }
}
</style>
